<template>
  <v-container class="pa-0">
    <v-form ref="styleForm" v-model="isValidComputed" class="pl-6 pb-2">
      <style-dialog-style-rows
        :has-copy-button="symbolizationType !== 'single'"
        :items="styleItems[simpleGeometryType]"
        v-model="computedLayerStyle"
        style-type="style"
      >
        <template #externalGraphic>
          <data-input
            :data-type="{ name: 'select' }"
            :items="icons"
            item-text="name"
            item-value="name"
            :auto-convert-select="false"
            height="20"
            v-model="computedLayerStyle['externalGraphic']"
          >
            <template #selection="{ item }">
              <img width="20px" height="20px" :src="getStyleExternalGraphicIcon(item.name)" class="mr-1" />
              {{ item.name.replace('.svg', '') }}
            </template>
            <template #item="{ item }">
              <img width="20px" height="20px" :src="getStyleExternalGraphicIcon(item.name)" class="mr-1" />
              {{ item.name.replace('.svg', '') }}
            </template>
          </data-input>
        </template>
        <template #zoom="input">
          <style-dialog-zoom-input
            :inputBind="input"
            :minzoom.sync="computedLayerStyle['minzoom']"
            :maxzoom.sync="computedLayerStyle['maxzoom']"
          />
        </template>
      </style-dialog-style-rows>
    </v-form>
    <style-dialog-style-preview
      class="border-top justify-center align-center"
      style="height: 200px"
      :layer-style="computedLayerStyle"
      :geometry-type="simpleGeometryType"
      :is-style-valid="isValidComputed"
    />
  </v-container>
</template>
<script>
import { call, get } from 'vuex-pathify';

import style from '@/mixins/style';
import stylePreviewUtilities from '@/mixins/stylePreviewUtilities';

import DataInput from '@/components/DataInput';
import StyleDialogStyleRows from '@/components/StyleDialogStyleRows';
import StyleDialogStylePreview from '@/components/StyleDialogStylePreview';
import StyleDialogZoomInput from '@/components/StyleDialogZoomInput';

export default {
  name: 'StyleDialogStyleTab',
  mixins: [style, stylePreviewUtilities],
  components: {
    DataInput,
    StyleDialogStyleRows,
    StyleDialogStylePreview,
    StyleDialogZoomInput,
  },
  props: {
    geometryType: {
      type: String,
      required: true,
    },
    isValid: {
      type: Boolean,
      default: false,
    },
    layerStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    symbolizationKind: {
      type: String,
      default: 'point',
    },
    symbolizationType: {
      type: String,
      default: 'single',
    },
  },
  computed: {
    icons: get('layers/icons'),
    computedLayerStyle: {
      get() {
        return this.layerStyle;
      },
      set(nV) {
        this.$emit('update:layerStyle', nV);
      },
    },
    isValidComputed: {
      get() {
        return this.isValid;
      },
      set(nV) {
        this.$emit('update:isValid', nV);
      },
    },
    simpleGeometryType() {
      return this.geometryType.replace('multi', '');
    },
  },
  data: () => ({
    payload: {},
  }),
  methods: {
    getIcons: call('layers/getIcons'),
  },
  mounted() {
    this.$root.$off('iconDeleted');
    this.$root.$on('iconDeleted', name => {
      if (name === this.computedLayerStyle['externalGraphic']) {
        this.computedLayerStyle['externalGraphic'] = this.icons[0].name;
      }
    });
    if (['point', 'polygon'].includes(this.simpleGeometryType)) {
      if (this.icons.length < 1) {
        this.getIcons();
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.radio-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;
  color: #202124;
}
.radio-subheader {
  font-family: Roboto;
  font-style: italic;
  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
  color: rgba(0, 0, 0, 0.59);
}
.border-top {
  border-top: 1px solid rgba(32, 33, 36, 0.18);
}
::v-deep .v-input--selection-controls__input {
  padding-bottom: 12px;
  margin-right: 0px;
}
::v-deep .v-input--selection-controls__input .v-icon {
  font-size: 22px;
}
::v-deep .v-input--selection-controls__ripple::before {
  left: 1px;
  top: -4px;
  max-width: 25px;
  max-height: 25px;
}
</style>
